// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_1uVNP","icon":"index_icon_1kWAK","setIcon":"index_setIcon_3_xou","setIconActive":"index_setIconActive_CNAJ2","link":"index_link_1bMK4"};